export const BLANK_HEADER = {destinationHeader: '', value: '', source: ''};
export const BLANK_PROXY_SETTINGS = {
    name: '', 
    policy: '', 
    method: '',
    endpoint: '',
    headers: []
};
export interface HeaderData {
    destinationHeader: string;
    value: string;
    source: string;
}

export interface ProxySettingsData {
    name: string;
    policy: string;
    method: string;
    //Endpoint is base64 encoded
    endpoint: string;
    headers: HeaderData[];
}
